import React, { Component } from 'react';
import {GuessLikeConfig} from '@config/GuessLikeConfig';
import {actions} from "@modules/wrap-redux/index";
import createMsg from "@modules/createMsg";
import {setlog} from '@modules/58m';
export default class GuessLike extends Component {
  sendMessage=(type,index,event)=>{
    event.stopPropagation();
    let actionType = type=="questionTxtList"?"mchatbot_cardask_click_"+(index+1):"mchatbot_cardlist_click_"+(index+1);
    setlog(actionType)
    let label = event.currentTarget.getAttribute('data-label');
    let value = event.currentTarget.getAttribute('data-value');
    let msg = createMsg({value,label});
    actions.chatAreaData.sendMsg({data:msg});
  }
  render() {
    return (
        <div className="module-guesslike">
          <div className="content-wrap">
            <div className="content-list">
              <div className="list-title"></div>
              <ul className="list-content">
                {
                  GuessLikeConfig.questionTxtList.map((item,index)=>{
                    return (
                      <li className={`list-item ${item.mark!==undefined?'mark-icon '+item.mark:null }`} key={"questionTxtList"+index} data-value={item.value} data-label={item.label} onClick={this.sendMessage.bind(this,'questionTxtList',index)}>
                        {item.label}
                        {item.mark!==undefined?
                        <i className={`mark-icon ${item.mark}`}></i>:null}
                        <i className="iconfont icon-click_guideblack_ic arrow-right"></i>
                      </li>
                    )
                  })
                }
              </ul>
            </div>
            <div className="content-card">
                {
                  GuessLikeConfig.shortcutCardList.map((item,index)=>{
                    return (
                      <div className={`card-item ${item.style} ${item.mark!==undefined?'mark-icon '+item.mark:null }`} data-value={item.value} data-label={item.label} key={"shortcutCardList"+index} onClick={this.sendMessage.bind(this,'shortcutCardList',index)}>
                        <div className="card-item-pic"></div>
                        <div className="card-item-main-title">{item.label}</div>
                        <div className="card-item-subtitle">{item.subtitle}</div>
                       </div>
                    )
                  })
                }
            </div>
          </div>
        </div>

    );
  }
}
